import React, { forwardRef } from 'react'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import '../../Styles/TableComponent.css'
import TableSortLabel from '@mui/material/TableSortLabel'
import { cn } from '../../lib/utils'

const GrcTable = forwardRef(({ className, children, ...props }, ref) => (
    <Table
    ref={ref}
    className={cn('', className)}
    {...props}
    >
        {children}
    </Table>
))

const GrcTableContainer = forwardRef(({ className, children, ...props }, ref) => (
    <TableContainer
    ref={ref}
    className={cn('table-component-container', className)}
    {...props}
    >
        {children}
    </TableContainer>
))

const GrcTableHead = forwardRef(({ className, children, ...props }, ref) => (
    <TableHead
    ref={ref}
    className={cn('', className)}
    {...props}
    >
        {children}
    </TableHead>
))

const GrcTableBody = forwardRef(({ className, children, ...props }, ref) => (
    <TableBody
    ref={ref}
    className={cn('', className)}
    {...props}
    >
        {children}
    </TableBody>
))

const GrcTableHeadRow = forwardRef(({ className, children, ...props }, ref) => (
    <TableRow
    ref={ref}
    className={cn('table-header-row', className)}
    {...props}
    >
        {children}
    </TableRow>
))

const GrcTableRow = forwardRef(({ className, children, ...props }, ref) => (
    <TableRow
    ref={ref}
    className={cn('', className)}
    {...props}
    >
        {children}
    </TableRow>
))

const GrcTableCell = forwardRef(({ className, children, ...props }, ref) => (
    <TableCell
    ref={ref}
    className={cn('', className)}
    {...props}
    >
        {children}
    </TableCell>
))

const GrcTableSortLabel = forwardRef(({ className, children, ...props }, ref) => (
    <TableSortLabel
    ref={ref}
    className={cn('', className)}
    {...props}
    >
        {children}
    </TableSortLabel>
))

export { GrcTable, GrcTableContainer, GrcTableHead, GrcTableBody, GrcTableHeadRow, GrcTableRow, GrcTableCell, GrcTableSortLabel }
